import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
    selector: 'app-map-dialog',
    templateUrl: './map-dialog.component.html',
    styleUrls: ['./map-dialog.component.scss']
})
export class MapDialogComponent implements OnInit {

    confirmButton = false;
    confirmText: any;
    isShowCloseButton = true;
    zoom: number = 4;
    color: string = "#73B2E4";
    latPointA: number;
    lngPointA: number;
    lablePointA: string = 'A';
    latPointB: number;
    lngPointB: number;
    lablePointB: string = 'B';
    directionsData: any;
    origin: any;
    destination: any;
    distanceWithDuration: any;
    steps: any;
    poilylinePath: any;
    copyRights: any;
    icon = {
        url: '/assets/images/google_map.svg',
        scaledSize: {
          width: 60,
          height: 60
        }
      }


    constructor(
        private dialogRef: MatDialogRef<MapDialogComponent>,
        @Inject(MAT_DIALOG_DATA) confirmText?: any) {
        this.confirmText = confirmText;
        this.directionsData = confirmText.dir;
    }

    ngOnInit() {
        this.origin = this.directionsData.request.origin.query;
        this.destination = this.directionsData.request.destination.query;
        this.distanceWithDuration = this.directionsData.routes[0].legs[0].distance.text + `. About ` + this.directionsData.routes[0].legs[0].duration.text;
        this.steps = this.directionsData.routes[0].legs[0].steps;
        this.copyRights = this.directionsData.routes[0].copyrights;
        this.poilylinePath = this.directionsData.routes[0].overview_path;
        this.latPointA = this.directionsData.routes[0].legs[0].start_location.lat();
        this.lngPointA = this.directionsData.routes[0].legs[0].start_location.lng();
        this.latPointB = this.directionsData.routes[0].legs[0].end_location.lat();
        this.lngPointB = this.directionsData.routes[0].legs[0].end_location.lng();
    }

    onConfirm() {
        this.confirmButton = true;
        this.dialogRef.close({ confirmResult: this.confirmButton });
    }

    onClose(value: any) {
        this.confirmButton = value;
        this.dialogRef.close({ confirmResult: this.confirmButton });
    }

}
